/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

require("@rails/ujs").start()
require("turbolinks").start()
require("slick-carousel")
require("jquery-ui")
require("jquery-ui/ui/widget")
require("jquery-ui/ui/widgets/menu")
require("jquery-ui/ui/keycode")
require("jquery-ui/ui/position")
require("jquery-ui/ui/unique-id")
require("jquery-ui/ui/safe-active-element")
require("jquery-ui/ui/widgets/autocomplete")
// tempusdominus requires global moment to be set.
window.moment = require("moment/moment")
require("moment/locale/ja.js")
require("tempusdominus-bootstrap-4/build/js/tempusdominus-bootstrap-4")
require("@nathanvda/cocoon")

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

window.$ = window.JQuery = $;

import 'bootstrap'
import 'core-js'

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"

window.disableLinkedSmaregiForms = function() {
  const forms = document.querySelectorAll('form.linked_smaregi_id');
  const skipDisable = ['no-disable', '_method', 'authenticity_token'];

  forms.forEach(form => {
    const elements = form.querySelectorAll('input, select, textarea, button, a');

    elements.forEach(el => {
      if (skipDisable.some(cls => el.classList.contains(cls) || el.name === cls)) {
        return;
      }

      if (el.tagName.toLowerCase() === 'a') {
        el.classList.add('disabled');
      } else {
        el.disabled = true;
      }
    });
  });
};


const application = Application.start()
const context = require.context("../controllers", true, /\.js$/)
application.load(definitionsFromContext(context))
